import { render, staticRenderFns } from "./dal-comp-customer.vue?vue&type=template&id=b90b9574"
import script from "./dal-comp-customer.vue?vue&type=script&lang=js"
export * from "./dal-comp-customer.vue?vue&type=script&lang=js"
import style0 from "./dal-comp-customer.vue?vue&type=style&index=0&id=b90b9574&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports